<template>
    <div style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: #210F0380; z-index: 9999; display: flex; justify-content: center; align-items: center;">
        <div style="border-radius: 24px; position: relative; background-color: #fff; width: 350px; height: 400px; display: flex; flex-direction: column;">
            <div @click="closeModifyPopup" style="margin-left: 20px; margin-top: 16px; font-weight: 700; position: relative; z-index: 2;">닫기</div>
            <div style="position: absolute; z-index: 1; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <img style="width: 308px;" :src="require('@/assets/img/modify_star.png')" alt="">
            </div>
            <div style="margin-top: 8px; text-align: center; flex: 1;">
                <div v-if="$GlobalStore.modifyPopupInfo().mode === MEMBER_CAREER_HISTORY_STATE.APPROVED">
                    <img style="width: 152px;" :src="require('@/assets/img/modify_complete.png')" alt="">
                </div>
                <div v-else-if="$GlobalStore.modifyPopupInfo().mode === MEMBER_CAREER_HISTORY_STATE.REJECT">
                    <img style="width: 108px;" :src="require('@/assets/img/modify_reject.png')" alt="">
                </div>
                <div v-if="$GlobalStore.modifyPopupInfo().mode === MEMBER_CAREER_HISTORY_STATE.APPROVED" style="margin-top: 15px; font-weight: 700; font-size: 20px; line-height: 24px;">팀 정보 수정이<br>완료되었습니다.</div>
                <template v-else-if="$GlobalStore.modifyPopupInfo().mode === MEMBER_CAREER_HISTORY_STATE.REJECT">
                    <div style="margin-top: 15px; font-weight: 700; font-size: 20px; line-height: 24px;">팀 정보 수정 요청이<br>승인되지 않았습니다.</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080; margin-top: 5px;">사유: {{$GlobalStore.modifyPopupInfo().reject_reason}}</div>
                </template>

            </div>
            <div @click="closeModifyPopup" style="width: 222px; position: relative; z-index: 2; height: 40px; line-height: 40px; font-size: 14px; border-radius: 20px; background-color: #210f03; text-align: center; margin: 0 auto; color: #fff; font-weight: 700; margin-bottom: 38px;">확인</div>
        </div>
    </div>
</template>

<script>
import {MEMBER_CAREER_HISTORY_STATE} from "../../Constants";
import ResponseCode from "../../ResponseCode";

export default {
    name: 'ModifyPopup',
    data(){
        return {
            MEMBER_CAREER_HISTORY_STATE : MEMBER_CAREER_HISTORY_STATE
        }
    },
    methods: {
        async closeModifyPopup() {
            const parameters = {};
            parameters.member_career_history_idx = this.$GlobalStore.modifyPopupInfo().member_career_history_idx;

            const res = await this.$Axios.post('/api/member/career_history/confirm', parameters);
            if(res.data.code === ResponseCode.SUCCESS){
                this.$GlobalStore.setIsShowModifyPopup(false)
            }else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
            }

        }
    }
}
</script>

<style scoped>

</style>